import TitleBlock from './TitleBlock'

export default TitleBlock
